export default "__VITE_ASSET__Bw4OrsbT__"